// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep {
  /* Container styles */
  /* Small devices (portrait phones, less than 576px) */
}
::ng-deep .journey-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  gap: 20px;
  align-items: stretch; /* Makes cards stretch to equal height */
  /* Card styles */
}
::ng-deep .journey-container .journey {
  flex: 1;
  min-width: 250px;
  background-color: white;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex; /* Added to control inner content */
  flex-direction: column; /* Stack content vertically */
  overflow: hidden;
  /* Bottom section container */
}
::ng-deep .journey-container .journey h4 {
  margin-bottom: 0.25rem !important;
}
::ng-deep .journey-container .journey p {
  color: #666;
  line-height: 1.5;
  margin-bottom: 0; /* Removes extra margin at bottom */
  flex-grow: 1; /* Allows text to expand to fill space */
}
::ng-deep .journey-container .journey .step {
  text-transform: uppercase;
  font-size: 0.75em !important;
  color: var(--accent);
  padding: 0 0 0.25rem;
}
::ng-deep .journey-container .journey .slogan {
  font-weight: bold;
  color: var(--accent);
  padding-bottom: 1rem;
}
::ng-deep .journey-container .journey a.journey-a {
  font-size: 0.9em !important;
  color: #f17732;
  text-transform: uppercase;
  border-bottom: 1px solid var(--gray-4);
  line-height: 2.5;
  z-index: 2;
}
::ng-deep .journey-container .journey a.journey-a:hover {
  color: #f59331;
}
::ng-deep .journey-container .journey .bottom-section {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: auto;
  height: 100px;
  /* Styling for the solar panel image */
}
::ng-deep .journey-container .journey .bottom-section button {
  z-index: 1;
}
::ng-deep .journey-container .journey .bottom-section .solar-image {
  position: absolute;
  bottom: calc(-1rem - 96px);
  right: calc(-1rem - 92px);
  width: 180px; /* Adjust based on your image size */
  height: 180px;
  object-fit: cover; /* Ensure the image scales properly */
  clip-path: circle(50% at 50% 50%); /* Circular mask */
  z-index: 0; /* Behind the button */
}
@media (max-width: 575.98px) {
  ::ng-deep .journey-container {
    flex-direction: column;
    padding: 10px;
    align-items: flex-start; /* Resets to normal height */
  }
  ::ng-deep .journey-container .journey {
    width: 100%;
    margin-bottom: 15px;
  }
  ::ng-deep .journey-container .journey p {
    flex-grow: 0; /* Allows variable height on mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/journey/journey.component.scss"],"names":[],"mappings":"AAAA;EACC,qBAAA;EAwFA,qDAAA;AAtFD;AADC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA,EAAA,wCAAA;EAEA,gBAAA;AAEF;AADE;EACC,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA,EAAA,mCAAA;EACA,sBAAA,EAAA,6BAAA;EACA,gBAAA;EAuCA,6BAAA;AAnCH;AAFG;EACC,iCAAA;AAIJ;AADG;EACC,WAAA;EACA,gBAAA;EACA,gBAAA,EAAA,mCAAA;EACA,YAAA,EAAA,wCAAA;AAGJ;AAAG;EACC,yBAAA;EACA,4BAAA;EACA,oBAAA;EACA,oBAAA;AAEJ;AACG;EACC,iBAAA;EACA,oBAAA;EACA,oBAAA;AACJ;AAEG;EACC,2BAAA;EACA,cAAA;EACA,yBAAA;EACA,sCAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AAEI;EACC,cAAA;AAAL;AAKG;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EAMA,sCAAA;AARJ;AAII;EACC,UAAA;AAFL;AAMI;EACC,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,YAAA,EAAA,oCAAA;EACA,aAAA;EACA,iBAAA,EAAA,qCAAA;EACA,iCAAA,EAAA,kBAAA;EACA,UAAA,EAAA,sBAAA;AAJL;AAWC;EACC;IACC,sBAAA;IACA,aAAA;IACA,uBAAA,EAAA,4BAAA;EATD;EAWC;IACC,WAAA;IACA,mBAAA;EATF;EAWE;IACC,YAAA,EAAA,qCAAA;EATH;AACF","sourcesContent":["::ng-deep {\n\t/* Container styles */\n\t.journey-container {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tmax-width: 1200px;\n\t\tmargin: 0 auto;\n\t\tpadding: 20px;\n\t\tgap: 20px;\n\t\talign-items: stretch; /* Makes cards stretch to equal height */\n\n\t\t/* Card styles */\n\t\t.journey {\n\t\t\tflex: 1;\n\t\t\tmin-width: 250px;\n\t\t\tbackground-color: white;\n\t\t\tborder-radius: 1rem;\n\t\t\tpadding: 1rem;\n\t\t\tbox-shadow: 0 2px 5px rgba(0,0,0,0.1);\n\t\t\tdisplay: flex; /* Added to control inner content */\n\t\t\tflex-direction: column; /* Stack content vertically */\n\t\t\toverflow: hidden;\n\n\t\t\th4 {\n\t\t\t\tmargin-bottom: .25rem !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tcolor: #666;\n\t\t\t\tline-height: 1.5;\n\t\t\t\tmargin-bottom: 0; /* Removes extra margin at bottom */\n\t\t\t\tflex-grow: 1; /* Allows text to expand to fill space */\n\t\t\t}\n\n\t\t\t.step {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-size: .75em !important;\n\t\t\t\tcolor: var(--accent);\n\t\t\t\tpadding: 0 0 .25rem;\n\t\t\t}\n\n\t\t\t.slogan {\n\t\t\t\tfont-weight: bold;\n\t\t\t\tcolor: var(--accent);\n\t\t\t\tpadding-bottom: 1rem;\n\t\t\t}\n\n\t\t\ta.journey-a {\n\t\t\t\tfont-size: .9em !important;\n\t\t\t\tcolor: #f17732;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tborder-bottom: 1px solid var(--gray-4);\n\t\t\t\tline-height: 2.5;\n\t\t\t\tz-index: 2;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: #f59331;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t/* Bottom section container */\n\t\t\t.bottom-section {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-end;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-top: auto;\n\t\t\t\theight: 100px;\n\n\t\t\t\tbutton {\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\n\t\t\t\t/* Styling for the solar panel image */\n\t\t\t\t.solar-image {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: calc(-1rem - 96px);\n\t\t\t\t\tright: calc(-1rem - 92px);\n\t\t\t\t\twidth: 180px; /* Adjust based on your image size */\n\t\t\t\t\theight: 180px;\n\t\t\t\t\tobject-fit: cover; /* Ensure the image scales properly */\n\t\t\t\t\tclip-path: circle(50% at 50% 50%); /* Circular mask */\n\t\t\t\t\tz-index: 0; /* Behind the button */\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Small devices (portrait phones, less than 576px) */\n\t@media (max-width: 575.98px) {\n\t\t.journey-container {\n\t\t\tflex-direction: column;\n\t\t\tpadding: 10px;\n\t\t\talign-items: flex-start; /* Resets to normal height */\n\n\t\t\t.journey {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: 15px;\n\n\t\t\t\tp {\n\t\t\t\t\tflex-grow: 0; /* Allows variable height on mobile */\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
